import { Plugin } from 'hubspot-prosemirror/pm/state';
import { EditorView } from 'hubspot-prosemirror/pm/view';

export const initialState = {
  scrollToPos: null,
};

export const ScrollViewPlugin = new Plugin({
  state: {
    init() {
      return initialState;
    },
    apply(tr) {
      const meta = tr.getMeta(ScrollViewPlugin);
      if (meta) {
        return meta;
      }
      return initialState;
    },
  },
  view() {
    return {
      update: (view: EditorView) => {
        const pluginState = ScrollViewPlugin.getState(view.state);
        if (pluginState && pluginState.scrollToPos) {
          const dom = view.domAtPos(pluginState.scrollToPos);
          if ((dom.node as Element).scrollIntoView) {
            (dom.node as Element).scrollIntoView();
          }
        }
      },
    };
  },
});
